import React from 'react'
import { Prompt } from 'react-router-dom'
import { Alert, Center, LoadingOverlay, Text } from '@mantine/core'

import { ScriptFlow } from './Event/NewScript/components/ScriptFlow/ScriptFlow'
import { ScriptLayout } from './Event/NewScript/components/ScriptFlow/ScriptLayout'
import { ScriptProvider } from './Event/NewScript/hooks/state/ScriptProvider'

import { EmailLink } from '@/components/common/EmailLink'
import { EventTitle } from '@/components/common/EventTitle'
import { Shell } from '@/components/Shell'
import { Event } from '@/types'

export const NewScriptScreen = ({
  event,
  refetchEvent,
}: {
  event: Event
  refetchEvent: () => Promise<unknown>
}) => (
  <ScriptProvider
    event={event}
    loading={<LoadingOverlay visible />}
    error={
      <Shell
        header={{
          middle: <EventTitle>{event.name}</EventTitle>,
        }}
      >
        <Prompt
          when={event.is_ongoing}
          message="Event is still ongoing. Are you sure you want to leave?"
        />
        <Center>
          <Alert color="red">
            <Text align="center" size="lg" fw={600}>
              Sorry, we couldn't load the script for this event.
            </Text>
            <Text size="md">
              Please try to reload the page, if the error persist contact{' '}
              <EmailLink
                size="sm"
                email={import.meta.env.VITE_APP_SUPPORT_EMAIL}
              />
            </Text>
          </Alert>
        </Center>
      </Shell>
    }
  >
    <Shell header={{ middle: <EventTitle>{event.name}</EventTitle> }}>
      <Prompt
        when={event.is_ongoing}
        message="Event is still ongoing. Are you sure you want to leave?"
      />
      <ScriptLayout event={event}>
        <ScriptFlow event={event} refetchEvent={refetchEvent} />
      </ScriptLayout>
    </Shell>
  </ScriptProvider>
)
